// extracted by mini-css-extract-plugin
export default {"item":"Deliver_item__YyGZV","item-wp":"Deliver_item-wp__QqtJ4"};